import { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import ErrorImage from "../../assets/images/no-preview.jpeg";

export const FileDetailsModal = (props) => {
	const { fileModal, handleCloseFileModal, addDefaultSrc, downloadFile } = props;
  const imageSrc = fileModal.file_url || ErrorImage;
  const [loadedImageSrc, setLoadedImageSrc] = useState(null);
  const imageLoaded = loadedImageSrc === imageSrc;
	return (
    <Modal
      show={fileModal.show || false}
      onHide={handleCloseFileModal}
      className="ad-adduser-modal sc-copycal-modal view-atachment-modal"
      backdrop="static"
      enforceFocus={false}
      id="attachments-modal"
      data-testid="statorder-filemodal"
    >
      <Modal.Header closeButton data-testid="statorder-filemodal-close" />
      <Modal.Body>
        <div className="d-flex justify-content-end">
          <Button
            data-testid="statorder-filemodal-download"
            className="primary-btn primary-btn-outline"
            onClick={(e) => {
              e.stopPropagation();
              downloadFile(fileModal.url);
            }}
          >
            Download
          </Button>
        </div>
    <div style={{ height: "calc(100% - 50px)" }}>
      {!imageLoaded && (
        <div className="d-flex justify-content-center" role="status" aria-label="Loading image">
          <Spinner animation="border" />
        </div>
      )}
      <img
        data-testid="statorder-filemodal-image"
        id="order-image"
        src={imageSrc}
        alt={fileModal.file_name || "Attachment preview"}
        hidden={!imageLoaded}
        onLoad={() => setLoadedImageSrc(imageSrc)}
        onError={addDefaultSrc}
      />
      {imageLoaded && fileModal.file_name && (
        <p data-testid="statorder-filemodal-name">{fileModal.file_name}</p>
      )}
		</div>
        <div className="d-flex justify-content-center"></div>
      </Modal.Body>
    </Modal>
  );
};
